<!--
 * @author: JJ
 * @since: 2024-09-30
 * Cooperate.vue
-->
<template>
    <div class="container">
        <Header />
        <header-search></header-search>
        <mainTab :nindex="4" />
        <div class="w1400 pt20 pb30">
            <div v-html="content"></div>
            <!-- <div class="main_title"><span class="fs20">企业简介</span></div>
            <div class="mt45"><span class="fs20 lh24">{{ span }}</span></div> -->
            <!-- <img src="../../assets/static/images/jj_help_img.png" class="img" alt=""> -->
        </div>
        <!-- <div class="bgf h270">
            <div class="h270 flex-box w1400">
                <img src="../../assets/static/images/jj_help_middle.png" class="middle_img" alt="">
                <div class="flex-grow-1 pl80 fs18 col3">发展至今，集团业务已覆盖医美行业整形外科、微创、无创三大领域，运营医美药械品牌产品有韩国大熊制药 DAEWOONG
                    注射用交联透明质酸钠凝胶-婕尔®；韩国 HANS BIOMED 硅胶鼻部和面部假体-韩士生科®（韩士系列、晶彩®系列）、硅凝胶填充乳房植入体-蓓菈®；韩国KJ
                    MEDITECH可吸收性缝线-超线®；韩国泰雄TAEWOONG非吸收性缝线-级线®以及硅凝胶乳房植入体-玉花房®等医疗美容产品。产品均获得国家药品监督管理局认证，合规合法，全方位保障用户产品体验，致力于为中国医美行业的健康发展贡献力量。
                </div>
            </div>
        </div> -->
        <!-- <div class="ptb100">
            <div class="w1400">
                <div class="fs18 col3 lh22">
                    未来，集团将更加注重引进高品质、高品牌知名度的医疗美容产品，积极同全国各医美机构建立高效互动，多赢发展的战略模式，为其提供安全、健康、有效的医疗产品和服务。致力于创建中国医美材料专业化、规模化、规范化供应商平台，成为客户信赖的医美界翘楚，联合全国医疗美容机构，为中国医美材料产业健康、良性发展不懈努力！
                </div>
                <div class="main_title mt100 mb45"><span class="fs20">企业文化</span></div>
                <img src="../../assets/static/images/jj_help_bottom.png" class="bottom_img" alt="">
            </div>
        </div> -->
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { useHead } from '@unhead/vue'
const span = ref('        G&S集团创建于2002年，总部设立在上海，是一家国际高端医美品牌整合式运营服务商，专注于全球医美产品的中国总经销及市场化运营。集团拥有完整的市场营销团队、专业的品牌推广团队和优秀的医学技术支持团队，为品牌全生态赋能。\n\n\n        集团深耕医美行业二十余载，在全国成立了16家子公司，覆盖中国除港澳台外的31个省，200多个城市，并与全国5000余家医疗美容机构达成战略合作。目前集团已形成以上海总部为中心，以国内各大区域子公司为相互联动，协同发展的全国性战略布局，建立了遍布全国的医美产品销售业..')
onMounted(() => {
    useHead({
        title: "商务合作-小狮优选",
        meta: [
            { name: "description", content: "This is my page description" },
            { property: "og:title", content: "My Page Title" },
            { property: "og:description", content: "This is my page description" },
            { property: "og:url", content: "https://example.com/my-page" },
            { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    })
})


</script>
<script>
export default {
  
    data() {
        return {
            content: '',
        };
    },
    created() {
        this.getAgreement();
    },
    methods: {
        getAgreement() {
            this.$api.getPartnerAgreement({}).then(res => {
                if (res.code == 1) {
                    this.content = res.data.content;
                }
            })
        }
    },
};
</script>
<style lang="less" scoped>
.w1400 {
    width: 1400px;
    margin-left: auto;
    margin-right: auto;
}

.pt70 {
    padding-top: 70px;
}

.main_title {
    text-align: center;

    span {
        color: #626262;
        font-weight: 500;
        line-height: 25px;
        position: relative;

        &::after {
            content: '';
            width: 82px;
            height: 4px;
            background: #1275ff;
            position: absolute;
            left: 50%;
            bottom: -10px;
            transform: translateX(-50%);
        }
    }
}

span {
    white-space: pre-wrap;
}

.mt45 {
    margin-top: 45px;
}

.img {
    width: 732px;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 70px;
}

.pb100 {
    padding-bottom: 100px;
}

.h270 {
    height: 270px;
}

.middle_img {
    width: 485px;
    height: auto;
}

.pl80 {
    padding-left: 80px;
}

.ptb100 {
    padding: 100px 0;
}

.mt100 {
    padding-top: 100px;
}

.mb45 {
    margin-bottom: 45px;
}

.bottom_img {
    width: 1400px;
    height: auto;
}
</style>
